import React from 'react';

import {
  RenderTextField,
  RenderTextFieldProps,
} from 'shared/components/RenderTextField/RenderTextField';
import { ClinicBillingType } from '../types';

export const ClinicBillingField = (
  props: Omit<RenderTextFieldProps<ClinicBillingType>, 'name'> & {
    name: keyof ClinicBillingType;
  },
) => <RenderTextField<ClinicBillingType> {...props} />;
